import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.scss";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import { MiscProvider } from "./contexts/MiscContext.jsx";

import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
    // defaultOptions: {
    //     queries: {
    //         // @ts-ignore err: unknown -> err: AxiosError
    //         retry: (failureCount, err: AxiosError) => {
    //           if (err.response?.status === 401) {
    //             return false; // do not retry, trigger error
    //           }
      
    //           // otherwise, restore default
    //           const defaultRetry = new QueryClient().getDefaultOptions().queries?.retry;
      
    //           return Number.isSafeInteger(defaultRetry)
    //             ? failureCount < (typeof defaultRetry === 'number' ? defaultRetry : 0)
    //             : false;
    //         },
    //         // @ts-ignore err: unknown -> err: AxiosError
    //         onError: (err: AxiosError) => {
    //           if (err.response?.status === 401) {
    //             // clean up session state and prompt for login
    //             // ex: window.location.reload();
    //           }
    //           if (err.response?.status === 404) {
    //             console.log("We got a 404 response!");
    //           }
    //         },
    //       },
    // }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <AuthProvider>
        <MiscProvider>
            <QueryClientProvider client={queryClient} >
                <Router>
                    <App />
                </Router>
            </QueryClientProvider>
        </MiscProvider>
    </AuthProvider>
);
